import { createDateInNorwegianTime as d } from '@/services/new-utils.ts';

export const OCTOBER_2025_CAMPAIGN_END_DATE = d(2025, 11, 17, 0, 0);
